import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { IImage } from '../../../types/shared';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';

interface Props {
  image?: IImage;
}

const ImageHeader = ({ image }: Props) => (
  <Container id="image-header">
    <ImageContainer>
      {image ? (
        <DesktopImage
          alt={image.description || ''}
          image={image.gatsbyImageData}
          objectPosition="50% 50%"
        />
      ) : (
        <FallbackBackground />
      )}
    </ImageContainer>
  </Container>
);

export default ImageHeader;

const Container = styled.div`
  background: ${Colors.white};
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(34 34 34 / 2%) 0px 0px 6px -4px,
    rgb(34 34 34 / 15%) 0px 4px 8px -4px;
  box-sizing: border-box;
  position: relative;
`;

const FallbackBackground = styled.div`
  background: ${Colors.abnGradient};
  height: auto;
  min-height: 160px;

  ${mq.from.breakpoint.M`
    min-height: 440px;
  `}
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DesktopImage = styled(GatsbyImage)`
  display: block;
  height: 160px;
  position: relative;

  ${mq.from.breakpoint.M`
    height: 440px;
  `}

  &:after {
    background: linear-gradient(
      79.33deg,
      rgba(0, 0, 0, 0.5) 0.58%,
      rgba(0, 0, 0, 0.36) 18.66%,
      rgba(255, 255, 255, 5e-5) 57.93%
    );
    background-blend-mode: multiply, normal;
    bottom: 0%;
    content: '';
    display: block;
    height: 100%;
    left: 0%;
    position: absolute;
    right: 0%;
    top: 0%;
    width: 100%;
  }
`;
